import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import MaterialKit from "./plugins/material-kit";

Vue.use(MaterialKit);

Vue.mixin({
  methods: {
    localeLabel(label) {
      return Locale.localeText(label);
    },
    notifyVue(type = "default", text) {
      if (!text) {
        if (type === "success") {
          text = "Changes have been saved!";
        } else if (type === "danger") {
          text = "Action failed!";
        }
      }
      this.$notify({
        timeout: 2500,
        message: text,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: type,
      });
    },
  },
});
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
});
